module.exports = __webpack_public_path__ + "static/media/plantPal2_07.8d31487d.png";